// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8218 ? "aaea2bcf" : chunkId) + "." + {"8218":"b122915ca4026063","9627":"90eb2024400f9d84"}[chunkId] + ".js";
};